const pricingData = [
    {
        title: "Starter",
        price: "$249",
        popular: false,
        features: [
            { label: "Access to Paid Content", value: true },
            { label: "Reviews Engine & Company Directory", value: true },
            { label: "Access to Training Content", value: false },
            { label: "Propose & Vote on Topics of Interest", value: false },
            { label: "Monthly Written Q&A Enquiries", value: false },
            { label: "Monthly 30 min Webcall with Specialist", value: false }
        ]
    },
    {
        title: "Basic",
        price: "$499",
        popular: false,
        features: [
            { label: "Access to Paid Content", value: true },
            { label: "Reviews Engine & Company Directory", value: true },
            { label: "Access to Training Content", value: true },
            { label: "Propose & Vote on Topics of Interest", value: false },
            { label: "Monthly Written Q&A Enquiries", value: false },
            { label: "Monthly 30 min Webcall with Specialist", value: false }
        ]
    },
    {
        title: "Advance",
        price: "$1249",
        popular: true,
        features: [
            { label: "Access to Paid Content", value: true },
            { label: "Reviews Engine & Company Directory", value: true },
            { label: "Access to Training Content", value: true },
            { label: "Propose & Vote on Topics of Interest", value: true },
            { label: "Monthly Written Q&A Enquiries", value: 3 },
            { label: "Monthly 30 min Webcall with Specialist", value: 1 }
        ]
    },
    {
        title: "Pro",
        price: "$2999",
        popular: false,
        features: [
            { label: "Access to Paid Content", value: true },
            { label: "Reviews Engine & Company Directory", value: true },
            { label: "Access to Training Content", value: true },
            { label: "Propose & Vote on Topics of Interest", value: true },
            { label: "Monthly Written Q&A Enquiries", value: 5 },
            { label: "Monthly 30 min Webcall with Specialist", value: 3 }
        ]
    },
    {
        title: "Business",
        price: "Contact Us",
        popular: false,
        features: [
            { label: "Access to Paid Content", value: true },
            { label: "Reviews Engine & Company Directory", value: true },
            { label: "Access to Training Content", value: true },
            { label: "Propose & Vote on Topics of Interest", value: true },
            { label: "Monthly Written Q&A Enquiries", value: true },
            { label: "Monthly 30 min Webcall with Specialist", value: true }
        ]
    }
];

export default pricingData;
